import React from 'react';
import { Percent, AlignRight, Divide } from 'lucide-react';
import ToolResult, { ResultItem } from '../../../../../components/ui/ToolResult';

// Описания типов конвертации
const typeDescriptions = {
  percent: {
    name: 'Проценты',
    icon: Percent,
    description: 'Стандартное представление доли, где 100% = 1 целое'
  },
  decimal: {
    name: 'Десятичная дробь',
    icon: AlignRight,
    description: 'Число от 0 до 1, где 1 = 100%'
  },
  fraction: {
    name: 'Обыкновенная дробь',
    icon: Divide,
    description: 'Представление в виде дроби, где числитель и знаменатель показывают отношение'
  }
};

const ResultsOverview = ({ results }) => {
  if (!results) return null;

  const { 
    originalValue, 
    originalType, 
    convertedValue, 
    convertedType 
  } = results;

  const OriginalIcon = typeDescriptions[originalType].icon;
  const ConvertedIcon = typeDescriptions[convertedType].icon;

  return (
    <ToolResult title="Результат конвертации">
      <div className="space-y-3 mb-6">
        {/* Исходное значение */}
        <ResultItem 
          label={`Исходное значение (${typeDescriptions[originalType].name})`}
          value={originalValue}
          color="blue"
          icon={<OriginalIcon className="w-4 h-4" />}
        />

        {/* Конвертированное значение */}
        <ResultItem 
          label={`Конвертированное значение (${typeDescriptions[convertedType].name})`}
          value={typeof convertedValue === 'number' 
            ? convertedValue.toString() 
            : convertedValue
          }
          color="green"
          icon={<ConvertedIcon className="w-4 h-4" />}
        />
      </div>

      {/* Детальное описание типов конвертации */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-gray-50 dark:bg-gray-800/50 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
        {/* Исходный тип */}
        <div>
          <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-2 flex items-center">
            <OriginalIcon className="w-4 h-4 mr-2 text-blue-500" />
            {typeDescriptions[originalType].name}
          </h4>
          <p className="text-xs text-gray-600 dark:text-gray-400">
            {typeDescriptions[originalType].description}
          </p>
        </div>

        {/* Целевой тип */}
        <div>
          <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-2 flex items-center">
            <ConvertedIcon className="w-4 h-4 mr-2 text-green-500" />
            {typeDescriptions[convertedType].name}
          </h4>
          <p className="text-xs text-gray-600 dark:text-gray-400">
            {typeDescriptions[convertedType].description}
          </p>
        </div>
      </div>

      {/* Информационный блок */}
      <div className="mt-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded p-3 flex items-start">
        <div className="flex items-start">
          <div className="mt-0.5 mr-3">
            <Percent className="w-5 h-5 text-blue-500" />
          </div>
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Как читать результат
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Различные типы представления показывают одно и то же значение, 
              но в разных форматах. Выбирайте наиболее удобный для вас способ 
              отображения.
            </p>
          </div>
        </div>
      </div>
    </ToolResult>
  );
};

export default ResultsOverview;